import { FileUploadDesignTokens } from '@primeuix/themes/types/fileupload';

export const FILE_UPLOAD_STYLES: FileUploadDesignTokens = {
  css: () => `
.p-fileupload .p-message-text {
  font-size: 0.75rem;
}
`,
};
